import { extendBoundsByPointItem } from '../sources/point_items';
import { addPreviewLines, removePreviewLines } from './preview_lines';
import { addClusteredPins, removeClusteredPins } from './clustered_pins';

const addExploreItems = (map, id, items, renderPopup = null, bounds = null) => {
  if (!items) {
    return;
  }

  // Note: We may be able to combine trail and cc clusters together using an html-based pin
  // e.g. https://docs.mapbox.com/mapbox-gl-js/example/cluster-html/
  // Currently these are kept separate because it's hard to show a cluster pin that's divided into multiple colors (e.g. blue/gray)
  // This could improve performance by reducing overall number of layers and sources, but may also worsen performance
  // if HTML is too slow to render compared to GL
  const trails = [];
  const cc = [];
  items.forEach(item => {
    if (bounds) {
      extendBoundsByPointItem(bounds, item);
    }
    if (item.type === 'trail') {
      trails.push(item);
    } else {
      cc.push(item);
    }
  });

  // Initialize hoverlines source / layer
  addPreviewLines(map);

  // Initialize trail source / layer
  addClusteredPins(map, `${id}-trails`, trails, 'green', renderPopup);

  // Initialize community content source / layer
  addClusteredPins(map, `${id}-cc`, cc, 'gray', renderPopup);
};

const removeExploreItems = (map, id) => {
  removePreviewLines(map);
  removeClusteredPins(map, `${id}-trails`);
  removeClusteredPins(map, `${id}-cc`);
};

export { addExploreItems, removeExploreItems };
